import styled from 'styled-components';
import TimeInformations from '../../TimeInformations';
import { Order } from '@/apis/order/interface';
import RoundedRectangleCheckBox from '@/components/RoundedRectangleCheckBox';
import { OrderStatusType } from '@/@types/order';
import PrescriptionApprove from './PrescriptionApprove';
import PrescriptionCancelReason from '../waitingPayment/PrescriptionCancelReason';
import useOrderReadyViewModel from '@/hooks/order/useOrderReadyViewModel';
import OrderStatusResetConfirmModal from '../../modal/OrderStatusResetConfirmModal';
import PriceConfirmModal from '../../modal/PriceConfirmModal';
import PrescriptionDenyConfirmModal from '../../modal/PrescriptionDenyConfirmModal';

interface Props {
  order: Order;
}
const OrderReady = ({ order }: Props) => {
  const {
    OrderStatusResetModal,
    PriceModal,
    PrescriptionDenyModal,
    ...viewModel
  } = useOrderReadyViewModel({
    order
  });
  return (
    <>
      <TimeInformations order={order} />

      {/* DUR 등록 / 조제승인 / 조제거절 */}
      {viewModel.orderViewStatus === OrderStatusType.Ready && (
        <>
          <RoundedRectangleCheckBox
            isChecked={viewModel.agreements.isCheckedDur}
            onClick={() => viewModel.onPressAgreement('isCheckedDur')}
            content={
              <RadioContent>
                <span>[필수]&nbsp;</span>
                DUR에 처방전 등록 확인
              </RadioContent>
            }
          />
          <ButtonWrapper>
            <Button
              primary
              onClick={() =>
                viewModel.onChangeOrderViewStatus(
                  OrderStatusType.PrescriptionApproved
                )
              }
              disabled={!viewModel.agreements.isCheckedDur}>
              조제할게요
            </Button>
            <Button
              onClick={() =>
                viewModel.onChangeOrderViewStatus(
                  OrderStatusType.PrescriptionDenied
                )
              }>
              조제를 거절할게요
            </Button>
          </ButtonWrapper>
        </>
      )}

      {/* 조제승인 가격 입력 */}
      {viewModel.orderViewStatus === OrderStatusType.PrescriptionApproved && (
        <PrescriptionApprove
          agreements={viewModel.agreements}
          onSubmitPrice={() => viewModel.setPriceModal(true)}
          onPressAgreement={viewModel.onPressAgreement}
          price={viewModel.price}
          setPrice={viewModel.setPrice}
          onClickResetOrder={viewModel.onClickResetOrder}
          alternativeReason={viewModel.alternativeReason}
          onChangeAlternativeReason={viewModel.onChangeAlternativeReason}
          alternativeOptions={viewModel.alternativeOptions}
          isRequestPaymentDisabled={viewModel.isRequestPaymentDisabled}
          isPriceInputDisabled={viewModel.isPriceInputDisabled}
          alternativeLog={viewModel.alternativeLog}
          onChangeAlterNativeLog={viewModel.onChangeAlterNativeLog}
        />
      )}

      {/* 조제거절 사유 선택 */}
      {viewModel.orderViewStatus === OrderStatusType.PrescriptionDenied && (
        <PrescriptionCancelReason
          orderDenyReasons={viewModel.orderDenyReasons}
          cancelReason={viewModel.cancelReason}
          setCancelReason={viewModel.setCancelReason}
          onSubmitOrderCancelByPharmacy={
            viewModel.onSubmitOrderCancelByPharmacy
          }
          onClickReset={() => {
            viewModel.setCancelReason('');
            viewModel.onChangeOrderViewStatus(OrderStatusType.Ready);
          }}
        />
      )}

      {/* Modal */}
      {/* 조제 접수 초기화 */}
      <OrderStatusResetModal clickOverlayToClose={false} thin>
        <OrderStatusResetConfirmModal
          onClickApprove={viewModel.onResetOrderStatusInReady}
          onClickDeny={() => viewModel.setOrderStatusResetModal(false)}
        />
      </OrderStatusResetModal>

      {/* 가격 설정 */}
      <PriceModal clickOverlayToClose={false} thin>
        <PriceConfirmModal
          price={viewModel.price}
          onSubmitSetPrice={viewModel.onSubmitSetPrice}
          onCloseModal={() => viewModel.setPriceModal(false)}
        />
      </PriceModal>

      {/* 조제 거부 */}
      <PrescriptionDenyModal clickOverlayToClose={false} thin>
        <PrescriptionDenyConfirmModal
          cancelReason={viewModel.cancelReason}
          onCloseModal={viewModel.onChangePrescriptionDenyModal}
          onSubmitPrescriptionDeny={viewModel.onSubmitPrescriptionDeny}
        />
      </PrescriptionDenyModal>
    </>
  );
};

export default OrderReady;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 12px;
`;

const Button = styled.button<{ primary?: boolean }>`
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
  border: 1px solid;

  ${({ theme, primary }) => `
    ${theme.DF_TYPOGRAPHY.UI16SB};
    color: ${primary ? theme.DF_COLOR.WHITE : theme.DF_COLOR.GRAY600};
    background: ${primary ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.WHITE};
    border-color: ${
      primary ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.GRAY200
    }};
    
    &:hover:not(:disabled) {
      opacity: 0.7;
    }
  
    :disabled {
      background: ${theme.DF_COLOR.GRAY100};
      border-color: ${theme.DF_COLOR.GRAY100};
      cursor: default;
    }
  `};
`;

const RadioContent = styled.div`
  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI17R};
    color: ${theme.DF_COLOR.GRAY700};
    span {
      color: ${theme.DF_COLOR.PRIMARY500};
    }
  `};
`;
